import React from 'react'
import '../Concierge/concierge.css'
import Constant, { getCurrency } from '../../Constant.js'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
import '../Concierge/concierge-responsive.css'

class Addons extends React.Component {
  state = {
    activeTab: this.props.data.tab[0].id,
    activeAddOnTab: {},
    activeAddOnSubTab: 0,
    isLoading: false,
    initialLoading: false,
    cruise_id: this.props.data.cruise_id,
    tabList: this.props.data.tab,
    bookingId: this.props.data.id,
    title: this.props.data.cruise_data.cruise_name_en,
    circleTab: [],
    foodOrStoreSelectOnceData: {},
    cartList: [],
    cartItemList: {},
    showCart: false,
    descriptionExpand: 1,
    totalAmt: 0,
    bookingData: {},
    showCheckout: false,
    storeMinAmtOrder: {},
    detailsOfitem: '',
    enable_b2b_prices: this.props.data.enable_b2b_prices,
    // Individual loading states
    isLoadingStores: false,
    isLoadingItems: false,
    isProcessingCheckout: false,
    isProcessingPayment: false,
  }

  componentDidMount() {
    this.imageManger = this.imageManger.bind(this)
    this.storeMinOrderAmtAlert = this.storeMinOrderAmtAlert.bind(this)
    this.tabHandler()
  }

  // Inline loader component
  renderInlineLoader = (height = 100) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: height,
          width: '100%',
        }}
      >
        <div
          style={{
            width: 30,
            height: 30,
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #00547e',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    )
  }

  setActiveTab = (tabDetail) => {
    this.setState({
      activeTab: tabDetail,
      activeAddOnSubTab: 0,
      circleTab: [],
      activeAddOnTab: {},
      foodOrStoreSelectOnceData: {}
    }, () => {
      this.tabHandler()
    })
  }

  setActiveAddOnTab = (subTabName) => {
    this.setState({ activeAddOnTab: subTabName, activeAddOnSubTab: 0, foodOrStoreSelectOnceData: {} }, () => {
      if (this.state.activeTab != 'FUN') {
        this.cruiseFoodOrStoreSelectedDetails()
      }
    })
  }

  setActiveAddOnSubTab = (subChildTabName) => {
    this.setState({ activeAddOnSubTab: subChildTabName })
  }

  tabHandler = () => {
    if (this.state.activeTab == 'FUN') {
      this.cruiseDiwaniyaList()
    } else {
      this.cruiseFoodOrStore()
    }
  }

  cruiseDiwaniyaList = () => {
    this.setState({
      isLoadingStores: true,
    })
    axios
      .get(Constant.getAPI() + '/items/cruise-diwaniya-list/' + this.state.cruise_id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState(
            {
              circleTab: res.data.data,
            },
            () => {
              this.setActiveAddOnTab(res.data.data[0])
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoadingStores: false,
        })
      })
  }

  cruiseFoodOrStore = () => {
    this.setState({
      isLoadingStores: true,
    })
    axios
      .get(
        Constant.getAPI() + `/booking/stores-by-type?type=${this.state.activeTab}&bookingId=` + this.state.bookingId,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          this.setState(
            {
              circleTab: res.data.data,
            },
            () => {
              this.setActiveAddOnTab(res.data.data[0])
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoadingStores: false,
        })
      })
  }

  cruiseFoodOrStoreSelectedDetails = () => {
    this.setState({
      isLoadingItems: true,
      foodOrStoreSelectOnceData: {},
    })
    axios
      .get(
        Constant.getAPI() +
        `/booking/store-items-by-store?id=${this.state.activeAddOnTab.id}&bookingId=` +
        this.state.bookingId,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({
            foodOrStoreSelectOnceData: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoadingItems: false,
        })
      })
  }

  imageManger = (value) => {
    let imgUrl = Constant.getImage()
    if (value) {
      imgUrl = imgUrl + value
    } else {
      imgUrl = './assets/images/waves-logo.svg'
    }

    return (
      <img
        alt=""
        src={imgUrl}
        onError={({ currentTarget }) => {
          currentTarget.src = './assets/images/waves-logo.svg'
        }}
      // style={{ width: 30, height: 'auto' }}
      />
    )
  }

  addOrRemoveFromCart = async (data, value) => {
    let obj = { ...data }
    let total = 0
    let StoreObj = { ...this.state.storeMinAmtOrder }
    if (this.state.itemaddingRemove) {
      return
    }
    let id = obj.id
    let price = obj.price
    let list = this.state.cartItemList

    if (!value) {
      if (!(list['id' + id] && list['id' + id].id)) {
        return
      } else {
        list['id' + id].qty = list['id' + id].qty - 1
        if (list['id' + id].qty == 0) {
          delete list['id' + id]
        }
        if (obj.storeId) {
          let totalAmtOfStireItem = StoreObj['pId' + obj.storeId] ? StoreObj['pId' + obj.storeId]?.amt : 0
          StoreObj['pId' + obj.storeId] = {
            amt: totalAmtOfStireItem - price,
            orderAmt: data.orderAmt,
            name: data.storeName,
          }
        }
        total = this.state.totalAmt - price
      }
    } else {
      let qtyIs = list['id' + id] ? list['id' + id].qty : 0
      if (obj.stock_limit && obj.stock_limit <= qtyIs) {
        Swal.fire('Item out of Stock', '', 'warning')
        return
      }
      if (!(list['id' + id] && list['id' + id].id)) {
        list['id' + id] = {
          ...obj,
          qty: 1,
          id: obj.id,
          img: obj.img,
          title: obj.title,
          price: obj.price,
          notes: obj.notes,
          store_item_option_id: obj.store_item_option_id,
        }
      } else {
        if (obj?.diwaniya) {
          Swal.fire('You can select max 1 qty per item', '', 'warning')
          return
        }
        if (list['id' + id].qty > 0) {
          list['id' + id].qty = list['id' + id].qty + 1
        }
      }
      if (obj.storeId) {
        let totalAmtOfStireItem = StoreObj['pId' + obj.storeId] ? StoreObj['pId' + obj.storeId]?.amt : 0
        StoreObj['pId' + obj.storeId] = {
          amt: totalAmtOfStireItem + price,
          orderAmt: data.orderAmt,
          name: data.storeName,
        }
      }
      total = this.state.totalAmt + price
    }
    this.setState({
      cartItemList: { ...list },
      totalAmt: total,
      storeMinAmtOrder: { ...StoreObj },
    })
  }

  Checkout = () => {
    let arr = Object.values(this.state.cartItemList)
    let additional_items_list = []
    let diwaniya_items_list = []
    let a = Object.values(this.state.storeMinAmtOrder).find((value) => value.amt < value.orderAmt && value.amt != 0)
    if (a) {
      Swal.fire(
        `${a.name} is ${a.orderAmt} ${getCurrency(localStorage.getItem('countryShortName'))} mininum`,
        '',
        'warning'
      )
      return
    }
    for (let item of arr) {
      if (item.diwaniya) {
        diwaniya_items_list.push({
          add_item_id: item.id,
          amount: item.price,
          cruise_id: this.state.cruise_id,
          item_qty: item.qty,
          notes: item?.notes,
          store_item_option_id: item?.store_item_option_id || '',
        })
      } else {
        additional_items_list.push({
          add_item_id: item.id,
          amount: item.price,
          store_id: item.store_id,
          item_qty: item.qty,
          notes: item?.notes,
          store_item_option_id: item?.store_item_option_id || '',
        })
      }
    }
    const data = {
      diwaniya_items_list: diwaniya_items_list,
      additional_items_list: additional_items_list,
      booking_id: this.state.bookingId,
      is_b2b: this.state.enable_b2b_prices,
    }
    this.onCheckout(data)
  }

  productCard = (img, title, price, data, checkQty = 0) => {
    let obj = data
    obj['qty'] = this.state.cartItemList['id' + data.id] ? this.state.cartItemList['id' + data.id].qty || 0 : 0
    obj['store_item_option_id'] = this.state.cartItemList['id' + data.id]
      ? this.state.cartItemList['id' + data.id].store_item_option_id || ''
      : ''
    obj['notes'] = this.state.cartItemList['id' + data.id] ? this.state.cartItemList['id' + data.id].notes || '' : ''
    obj['img'] = img
    obj['title'] = title
    obj['price'] = price

    if (checkQty && !obj.qty) {
      return
    }
    return (
      <div className="add-box-data">
        <div onClick={() => this.setState({ detailsOfitem: data })}>{this.imageManger(img)}</div>
        <div className="box-under-data">
          <p>{title}</p>
          <div className="under-data-price">
            <p>
              {this.state.cartItemList['id' + data.id] ? this.state.cartItemList['id' + data.id].price : price}{' '}
              {getCurrency(localStorage.getItem('countryShortName'))}
            </p>
            {data.store_item_options && data.store_item_options.length ? (
              <div
                className="showwAll"
                onClick={() => this.setState({ detailsOfitem: obj })}
              >
                Show All
              </div>
            ) : (
              <div className="count-data">
                <span
                  className="box"
                  onClick={() => this.addOrRemoveFromCart(data, 0)}
                >
                  -
                </span>
                <div>{obj.qty}</div>
                <span
                  className="box"
                  onClick={() => this.addOrRemoveFromCart(data, 1)}
                >
                  +
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  handleCart = () => {
    this.setState({ showCart: this.state.showCheckout ? 1 : 0, showCheckout: 0 })
  }

  onCheckout = async (data) => {
    this.setState({ isData: true, isProcessingCheckout: true, bookingData: {} })

    await axios
      .post(Constant.getAPI() + '/booking/admin-cruise-checkout/', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            bookingData: res.data.data,
            showCheckout: true,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isData: false,
          isProcessingCheckout: false,
        })
      })
  }

  processPayment = async () => {
    this.setState({ isProcessingPayment: true })
    const body = {
      booking_id: this.state.bookingData?.id,
      is_b2b: this.state.enable_b2b_prices,
    }
    await axios
      .post(Constant.getAPI() + '/booking/process-payment', body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire({
            title: 'Payment Success',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Booking Details',
          }).then(() => {
            window.location.href = `#/booking-ordering/${body.booking_id}`
          })
          this.props.clearData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isProcessingPayment: false,
        })
      })
  }

  bottmBtn = () => {
    if (this.state.showCart) {
      this.Checkout()
    } else {
      let a = Object.values(this.state.storeMinAmtOrder).find((value) => value.amt < value.orderAmt && value.amt != 0)
      if (a) {
        Swal.fire(
          `${a.name} is ${a.orderAmt} ${getCurrency(localStorage.getItem('countryShortName'))} mininum`,
          '',
          'warning'
        )
        return
      }
      let tabList = [...this.state.tabList]
      let indexOfCurrentTab =
        this.state.tabList.findIndex((ele) => {
          return ele.id == this.state.activeTab
        }) + 1
      if (indexOfCurrentTab == tabList.length) {
        this.setState({
          showCart: 1,
        })
      } else {
        this.setActiveTab(tabList[indexOfCurrentTab].id)
      }
    }
  }

  storeMinOrderAmtAlert = () => {
    let store = this.state.storeMinAmtOrder['pId' + this.state.foodOrStoreSelectOnceData.id]
    if (store && store.amt < store.orderAmt && store.amt != 0 && !this.state.showCart && !this.state.showCheckout) {
      return (
        <div
          style={{
            background: 'aqua',
            fontSize: '13px',
            textAlign: 'center',
          }}
        >
          Minimum Order limit of {store.name} is {store.orderAmt}{' '}
          {getCurrency(localStorage.getItem('countryShortName'))}
        </div>
      )
    } else {
      return ''
    }
  }

  changeItemDetail = (type, value, other) => {
    let obj = { ...this.state.detailsOfitem }
    if (type == 'QTY') {
      obj.qty = (obj.qty || 0) + (value ? 1 : -1)
      if (other < obj.qty) {
        Swal.fire('Item out of Stock', '', 'warning')
        return
      }

      if (obj?.diwaniya && obj.qty > 1) {
        Swal.fire('You can select max 1 qty per item', '', 'warning')
        return
      }

      if (obj.qty < 0) {
        return
      }

      if (obj.qty == 0) {
        obj['notes'] = ''
        obj['store_item_option_id'] = ''
      }
    }

    if (type == 'NOT') {
      obj['notes'] = value
    }

    if (type == 'OPT') {
      obj['store_item_option_id'] = value

      let store_item_option = other.find((e) => {
        return e.id == value
      })
      obj['price'] = store_item_option.price
    }
    this.setState({ detailsOfitem: obj })
  }

  setDetailsOfitem = () => {
    let data = this.state.detailsOfitem
    return (
      <div>
        <div className="App">
          <div
            className="popup-backdrop"
            onClick={() => this.setState({ detailsOfitem: '' })}
          >
            <div
              className="popup-content height-width-fix"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="popup-close"
                onClick={() => this.setState({ detailsOfitem: '' })}
              >
                <img
                  src="./assets/icon/concierge/close-black.svg"
                  alt=""
                />
              </button>
              <div className="popupScroll">
                <div className="popup-data">
                  <div className="w-50">
                    <div>
                      <div className="slider-container img-250">{this.imageManger(data.img)}</div>
                    </div>
                  </div>
                  <div className="w-50">
                    <div>
                      <h3 className="m-0">{data.title}</h3>
                      <div
                        className="review-location"
                        style={{ height: '100px', alignItems: 'flex-start', lineHeight: '14px', fontSize: '10px' }}
                      >
                        {data.description}
                      </div>
                      <div>
                        <div className="row">
                          <div className="col-8">
                            {data.store_item_options && data.store_item_options.length ? (
                              <div className="item-dropdown">
                                <div
                                  className="w-100"
                                  style={{ lineHeight: '32px' }}
                                >
                                  Chose Your size
                                </div>
                                <div className="w-100">
                                  <select
                                    style={{ width: '100%', padding: '0', textAlign: 'center' }}
                                    name="country_code"
                                    className="form-control border-none"
                                    value={data.store_item_option_id}
                                    onChange={(event) => {
                                      this.changeItemDetail('OPT', event.target.value, data.store_item_options)
                                    }}
                                  >
                                    {data.store_item_options.map((ele) => {
                                      return <option value={ele.id}>{ele.name}</option>
                                    })}
                                  </select>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                          <div className="detail-price2 col-4">
                            {data.price} {getCurrency(localStorage.getItem('countryShortName'))}
                          </div>
                          <textarea
                            type="text"
                            disabled={(data.qty || 0) == 0}
                            className="form-control cruise_search col-12 my-2"
                            style={{ height: '46px' }}
                            name="cruise_search"
                            id="cruise_search"
                            placeholder={`Any Special request`}
                            onChange={(event) => {
                              this.changeItemDetail('NOT', event.target.value, '')
                            }}
                            value={data.notes}
                          />
                          <div className="count-data col-6">
                            <span
                              className="box"
                              onClick={() => this.changeItemDetail('QTY', 0, data.stock_limit)}
                            >
                              -
                            </span>
                            <div>{data.qty || 0}</div>
                            <span
                              className="box"
                              onClick={() => this.changeItemDetail('QTY', 1, data.stock_limit)}
                            >
                              +
                            </span>
                          </div>
                          <div className="col-6">
                            <button
                              className="btn book-btn "
                              disabled={(data.qty || 0) == 0}
                              type="button"
                              onClick={() => this.addBulkQty()}
                            >
                              Add To Cart {data.price * data.qty || 0}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  addBulkQty = () => {
    let list = this.state.cartItemList
    let StoreObj = { ...this.state.storeMinAmtOrder }
    let prevPrice = 0
    let prevQty = 0
    let obj = this.state.detailsOfitem
    let id = this.state.detailsOfitem.id
    if (list['id' + id]) {
      prevPrice = list['id' + id].price
      prevQty = list['id' + id].qty
    }
    list['id' + id] = {
      ...obj,
    }
    let min = -(prevPrice * prevQty)
    if (obj.storeId) {
      let totalAmtOfStireItem = StoreObj['pId' + obj.storeId] ? StoreObj['pId' + obj.storeId]?.amt : 0
      StoreObj['pId' + obj.storeId] = {
        amt: totalAmtOfStireItem + min + obj.price * obj.qty,
        orderAmt: obj.orderAmt,
        name: obj.storeName,
      }
    }

    this.setState({
      totalAmt: this.state.totalAmt + min + obj.price * obj.qty,
      cartItemList: { ...list },
      storeMinAmtOrder: { ...StoreObj },
      detailsOfitem: {},
    })
  }

  render() {
    const { activeTab, activeAddOnSubTab } = this.state
    return (
      <>
        <div className="scroll">
          <div>
            {(this.state.isProcessingCheckout || this.state.isProcessingPayment || this.state.initialLoading) && (
              <div className="loader-overlay">
                <div className="loader"></div>
              </div>
            )}
            {this.state.showCheckout ? (
              <div>
                <div className="top-button">
                  <div className="button-data">
                    <span>
                      <img
                        src="./assets/icon/concierge/arrow-prev-back.svg"
                        alt="Back"
                        style={{ width: '25px', cursor: 'pointer' }}
                        onClick={this.handleCart}
                      />
                    </span>
                    <h1 className="m-0 heading">Checkout</h1>
                    <div> </div>
                  </div>
                </div>

                <div className="checkout-padding">
                  {(() => {
                    const { bookingData } = this.state;
                    const isBookByDay = bookingData?.destination?.book_by === 'day';

                    // Calculate start and end times based on booking type
                    const startTime = isBookByDay
                      ? moment(bookingData?.destination?.check_in_time, 'HH:mm:ss').format('hh:mm A')
                      : moment(bookingData?.timeSlots?.[0]?.slot_from, 'HH:mm:ss').format('hh:mm A');

                    const endTime = isBookByDay
                      ? moment(bookingData?.destination?.check_out_time, 'HH:mm:ss').format('hh:mm A')
                      : moment(bookingData?.timeSlots?.[bookingData?.timeSlots?.length - 1]?.slot_to, 'HH:mm:ss').format('hh:mm A');

                    const durationHours = parseInt(bookingData?.destination?.destination_min_hour?.split(':')?.[0]) || 0;
                    const durationDays = moment(bookingData?.bookingDateTo, 'YYYY-MM-DD').diff(moment(bookingData?.bookingDate, 'YYYY-MM-DD'), 'days') + 1 || 1;

                    return (
                      <div className="checkout">
                        <div className="checkout-w-33">
                          <p>{moment(bookingData?.bookingDate, 'YYYY-MM-DD').format('dddd, D MMMM')}</p>
                          <h5>{bookingData?.pickUp?.pickup_address}</h5>
                          <span>{startTime}</span>
                        </div>
                        <div className="checkout-w-33 text-center checkout-yatch-data">
                          <h3>{bookingData?.paymentSummary?.cruise_name}</h3>
                          <p>{isBookByDay ? `${durationDays} ${durationDays > 1 ? 'Days' : 'Day'}` : `${durationHours} Hrs`}</p>
                          <p>{bookingData?.pickUp?.pickup_address}</p>
                        </div>
                        <div className="checkout-w-33 text-right">
                          <p>{moment(bookingData?.bookingDateTo, 'YYYY-MM-DD').format('dddd, D MMMM')}</p>
                          <h5>{bookingData?.destination?.destination_address}</h5>
                          <span>{endTime}</span>
                        </div>
                      </div>
                    );
                  })()}

                  <div className="payment-data">
                    <h3>Payment Summary</h3>

                    <div className="payment-details">
                      <p> Destination Total </p>
                      <h1>
                        {' '}
                        {this.state.bookingData?.paymentSummary?.destination_total}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="payment-details">
                      <p> Additional Hour Total </p>
                      <h1>
                        {' '}
                        {this.state.bookingData?.paymentSummary?.additional_hours_total}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="payment-details">
                      <p> Diwaniya Items Total </p>
                      <h1>
                        {' '}
                        {this.state.bookingData?.paymentSummary?.diwaniya_items_total}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="payment-details">
                      <p> Store Items Total </p>
                      <h1>
                        {' '}
                        {this.state.bookingData?.paymentSummary?.store_items_total}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="payment-details">
                      <p> Food Items Total </p>
                      <h1>
                        {' '}
                        {this.state.bookingData?.paymentSummary?.food_items_total}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="payment-details">
                      <p> Delivery Charge </p>
                      <h1>
                        {' '}
                        {this.state.bookingData?.paymentSummary?.deliveryCharge}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="payment-details">
                      <p> Cost Of Service </p>
                      <h1>
                        {' '}
                        {this.state.bookingData?.paymentSummary?.cost_of_service}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="payment-details">
                      <p> Coupon Applied Amount </p>
                      <h1>
                        {this.state.bookingData?.paymentSummary?.coupon_applied_amount}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="payment-details">
                      <p> Vat ({this.state.bookingData?.paymentSummary?.vat}%) </p>
                      <h1>
                        {this.state.bookingData?.paymentSummary?.vat_amount || 0}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="payment-details payment-details-total">
                      <p> Total </p>
                      <h1>
                        {' '}
                        {this.state.bookingData?.paymentSummary?.total_booking_amount}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </h1>
                    </div>
                    <div className="text-center buttondata">
                      <button
                        className="btn book-btn"
                        type="button"
                        onClick={this.processPayment}
                      >
                        Process Payment {this.state.bookingData?.paymentSummary?.total_booking_amount}{' '}
                        {getCurrency(localStorage.getItem('countryShortName'))}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="top-button">
                  <div className="button-data">
                    <span>
                      {this.state.showCart ? (
                        <img
                          src="./assets/icon/concierge/arrow-prev-back.svg"
                          alt="Back"
                          style={{
                            width: '25px',
                            cursor: 'pointer',
                          }}
                          onClick={this.handleCart}
                        />
                      ) : (
                        ''
                      )}
                    </span>
                    <h1 className="m-0 heading">{this.state.showCart ? 'Cart' : this.state.title}</h1>
                    <div
                      style={{
                        height: '22px',
                        position: 'relative',
                        cursor: 'pointer',
                      }}
                      onClick={() => this.setState({ showCart: this.state.showCart ? false : true })}
                    >
                      {' '}
                      <img
                        src="./assets/icon/concierge/cart.svg"
                        alt="Cart"
                        style={{
                          width: '30px',
                        }}
                      />
                      {Object.keys(this.state.cartItemList).length == 0 ? (
                        ''
                      ) : (
                        <span
                          className="m-0 heading"
                          style={{
                            position: ' absolute',
                            right: ' -4px',
                            top: ' -3px',
                            height: ' 19px',
                            width: ' 18px',
                            backgroundColor: ' #adadff',
                            fontSize: ' 10px',
                            textAlign: ' center',
                            borderRadius: ' 15px',
                            lineHeight: ' 18px',
                          }}
                        >
                          {Object.keys(this.state.cartItemList).length}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {this.state.showCart ? (
                  <div className="add-on-data">
                    {Object.keys(this.state.cartItemList).length ? (
                      <div className="data-add-box">
                        {Object.values(this.state.cartItemList)?.map((ele, i) => {
                          return <div key={i}>{this.productCard(ele.img, ele.title, ele.price, ele, 1)}</div>
                        })}
                      </div>
                    ) : (
                      <div className="mt-3 no-data">
                        <h5 className="">No Item Added</h5>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="add-on-data">
                    <div
                      style={{
                        overflow: 'auto',
                        padding: '0 10px',
                      }}
                    >
                      <div className="add-tab">
                        {this.state.tabList?.map((ele, i) => {
                          return (
                            <div
                              key={i}
                              className={`box ${activeTab === ele.id ? 'select' : ''}`}
                              onClick={() => this.setActiveTab(ele.id)}
                            >
                              {this.imageManger(ele.imageSelected)}
                              <p className="m-0">{ele.name}</p>
                            </div>
                          )
                        })}
                      </div>
                    </div>

                    <div className="tab-content">
                      <div className="add-cat">
                        {this.state.isLoadingStores ? (
                          this.renderInlineLoader(80)
                        ) : this.state.circleTab?.map((ele, i) => {
                          return (
                            <div
                              key={i}
                              className={`add-cat-data ${this.state.activeAddOnTab.id === ele.id ? 'select' : ''}`}
                              onClick={() => this.setActiveAddOnTab(ele)}
                            >
                              {this.imageManger(this.state.activeTab == 'FUN' ? ele.img : ele.shop_img)}
                              <p className="mb-1">{this.state.activeTab == 'FUN' ? ele.name : ele.shop_name}</p>
                            </div>
                          )
                        })}
                      </div>
                      {activeTab === 'FUN' && (
                        <div
                          style={{
                            overflow: 'auto',
                            padding: '0 10px',
                          }}
                        >
                          {this.state.activeAddOnTab?.cruise_diwaniya &&
                            this.state.activeAddOnTab?.cruise_diwaniya.length > 0 && (
                              <div className="data-add-box">
                                {this.state.activeAddOnTab?.cruise_diwaniya?.map((ele, i) => {
                                  return (
                                    <div key={i}>
                                      {this.productCard(ele.item_img_thumb, ele.item_name, ele.item_amount, {
                                        diwaniya: 1,
                                        ...ele,
                                      })}
                                    </div>
                                  )
                                })}
                              </div>
                            )}
                        </div>
                      )}
                      {activeTab != 'FUN' && (
                        <div>
                          {this.state.isLoadingItems ? (
                            this.renderInlineLoader(100)
                          ) : this.state.foodOrStoreSelectOnceData && Object.keys(this.state.foodOrStoreSelectOnceData).length > 0 && (
                            <>
                              <div className="box-details">
                                <h4>{this.state.foodOrStoreSelectOnceData?.name}</h4>
                                <ul>
                                  {Array.apply(null, Array(5))?.map((ele, i) => {
                                    return (
                                      <li key={i}>
                                        {i > this.state.foodOrStoreSelectOnceData?.ratings - 1 ? (
                                          <img
                                            src="./assets/icon/concierge/unfill-star.svg"
                                            alt=""
                                          />
                                        ) : (
                                          <img
                                            src="./assets/icon/concierge/star.svg"
                                            alt=""
                                          />
                                        )}
                                      </li>
                                    )
                                  })}
                                </ul>
                                <span
                                  onClick={() =>
                                    this.setState({ descriptionExpand: this.state.descriptionExpand ? 0 : 1 })
                                  }
                                >
                                  {this.state.descriptionExpand ? (
                                    <p>
                                      {this.state.foodOrStoreSelectOnceData?.description &&
                                        this.state.foodOrStoreSelectOnceData?.description.length > 100
                                        ? this.state.foodOrStoreSelectOnceData?.description.substring(0, 100) + '...'
                                        : this.state.foodOrStoreSelectOnceData?.description}
                                    </p>
                                  ) : (
                                    <p>{this.state.foodOrStoreSelectOnceData?.description}</p>
                                  )}
                                </span>
                                <div className="fee-del">
                                  <span>Delivery Fee:</span>
                                  <p>
                                    {this.state.foodOrStoreSelectOnceData?.deliverCharge}{' '}
                                    {getCurrency(localStorage.getItem('countryShortName'))}
                                  </p>
                                </div>
                              </div>
                              {this.state.foodOrStoreSelectOnceData.categories ? (
                                <div className="child-data">
                                  <div className="child-box">
                                    {this.state.foodOrStoreSelectOnceData?.categories.map((ele, index) => {
                                      return (
                                        <div
                                          key={index}
                                          className={`box ${activeAddOnSubTab == index ? 'select' : ''}`}
                                          onClick={() => this.setActiveAddOnSubTab(index)}
                                        >
                                          <p>{ele.name}</p>
                                        </div>
                                      )
                                    })}
                                  </div>
                                  <div>
                                    <div>
                                      {this.state.foodOrStoreSelectOnceData?.categories[activeAddOnSubTab] ? (
                                        <div className="data-add-box">
                                          {this.state.foodOrStoreSelectOnceData?.categories[
                                            activeAddOnSubTab
                                          ]?.storeItems.map((ele, index) => {
                                            return (
                                              <div key={index}>
                                                {this.productCard(ele.image, ele.name, ele.item_amount, {
                                                  ...ele,
                                                  storeId: this.state.foodOrStoreSelectOnceData?.id,
                                                  orderAmt: this.state.foodOrStoreSelectOnceData?.minimumOrderAmount,
                                                  storeName: this.state.foodOrStoreSelectOnceData?.name,
                                                })}
                                              </div>
                                            )
                                          })}
                                        </div>
                                      ) : (
                                        <div className="mt-3 no-data">
                                          <h5 className="">No Item</h5>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
            {this.state.detailsOfitem.id ? <div>{this.setDetailsOfitem()}</div> : ''}
          </div>
        </div>
        {!this.state.showCheckout && (
          <div>
            {this.storeMinOrderAmtAlert()}
            <div
              style={{
                padding: '10px 20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderTop: '1px solid #ccc',
              }}
            >
              <button
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
                type="button"
                className="btn book-btn"
                onClick={() => this.bottmBtn()}
              >
                {this.state.showCart ? (
                  <div>
                    {' '}
                    Checkout
                    {this.state.totalAmt ? (
                      <span>
                        {' ' + this.state.totalAmt + ' ' + getCurrency(localStorage.getItem('countryShortName'))}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                ) : (
                  <div>Next</div>
                )}
              </button>
            </div>
          </div>
        )}
      </>
    )
  }
}

export default Addons
